import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {
  notifications = [];
  tickets = [];
  show = 'notifications';
  defaultHref = '/tecservice/home';
  loading = false;

  constructor(
    private apiService: ApiService,
    private dataService: DataService,
    private loadingService: LoadingService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.router.url.indexOf('transportec') >= 0) {
      this.defaultHref = '/tecservice-transportec/wallet';
    }
    this.handleQueryParams();
    this.getNotifications();
    this.getTickets();
  }

  handleQueryParams() {
    const show = this.activatedRoute.snapshot.queryParams['show'];
    if (show && ['notifications', 'tickets'].includes(show)) {
      this.show = show;
    }
  }

  async getNotifications() {
    this.loading = true;
    const notificationsResponse = await this.apiService.getData('notifications');
    this.loading = false;
    this.notifications = notificationsResponse?.data || [];
  }

  async getTickets() {
    this.loading = true;
    const ticketsResponse = await this.apiService.getData('tickets');
    this.loading = false;
    this.tickets = ticketsResponse?.data || [];
  }

  goNotification(notification) {
    notification.read_at = true;
    this.dataService.setData(notification.id, notification);
    if (this.router.url.indexOf('transportec') >= 0) {
      console.log('transportec');
      this.router.navigate(['/tecservice-transportec/wallet/notifications/' + notification.id]);
    } else {
      this.router.navigate(['/tecservice/home/notifications/' + notification.id]);
    }
  }

  deleteNotification(notification) {
    this.loadingService.present();
    this.apiService
      .deleteData('notification/' + notification.id)
      .then((res) => {
        this.getNotifications();
      })
      .catch(() => {
        console.log('Error en borrar.');
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }

  goTicket(ticket) {
    this.dataService.setData(ticket.id, ticket);
    if (this.router.url.indexOf('transportec') >= 0) {
      this.router.navigate(['/tecservice-transportec/wallet/tickets/' + ticket.id]);
    } else {
      this.router.navigate(['/tecservice/home/tickets/' + ticket.id]);
    }
  }
}
